// assets/a24-dynamic-styles.js
/* Applies Liquid-provided style data without inline style attributes in templates. */
(function () {
  'use strict';

  function splitDeclarations(source) {
    // Trennt CSS-Deklarationen, ohne Semikolons innerhalb von Klammern zu zerlegen.
    var declarations = [];
    var current = '';
    var depth = 0;

    String(source || '').split('').forEach(function (char) {
      if (char === '(') depth += 1;
      if (char === ')' && depth > 0) depth -= 1;

      if (char === ';' && depth === 0) {
        if (current.trim()) declarations.push(current.trim());
        current = '';
        return;
      }

      current += char;
    });

    if (current.trim()) declarations.push(current.trim());
    return declarations;
  }

  function applyDeclaration(node, declaration) {
    // Unterstuetzt normale CSS-Properties und CSS Custom Properties.
    var separator = declaration.indexOf(':');
    if (separator === -1) return;

    var property = declaration.slice(0, separator).trim();
    var value = declaration.slice(separator + 1).trim();
    if (!property || !value) return;

    node.style.setProperty(property, value);
  }

  function applyDynamicStyles(scope) {
    var root = scope || document;
    var nodes = [];

    if (root.matches && root.matches('[data-a24-style]')) {
      nodes.push(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('[data-a24-style]').forEach(function (node) {
        nodes.push(node);
      });
    }

    nodes.forEach(function (node) {
      splitDeclarations(node.getAttribute('data-a24-style')).forEach(function (declaration) {
        applyDeclaration(node, declaration);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { applyDynamicStyles(document); }, { once: true });
  } else {
    applyDynamicStyles(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    applyDynamicStyles(event.target);
  });

  window.A24ApplyDynamicStyles = applyDynamicStyles;
}());
